import DOMPurify from 'dompurify';

export function sanitizeSVG(svg: string): string {
  // Use DOMPurify to sanitize the SVG
  return DOMPurify.sanitize(svg, {
    USE_PROFILES: { svg: true, svgFilters: true },
  });
}
